import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import GradientCircularProgress from '../components/common/GradientCircularProgress';
import useReportAndCompoundMeta from '../hooks/useReportAndCompoundMeta';

export default function TestResultsHistory() {
  const location = useLocation();
  const navigate = useNavigate();
  const reportDataFromState = location.state?.data;
  const { compoundMetaData, reportsDataWithScores, loading, errorMessage } =
    useReportAndCompoundMeta(reportDataFromState);

  useEffect(() => {
    const lastReport = reportsDataWithScores[reportsDataWithScores.length - 1];
    if (lastReport) {
      navigate(`/report/${lastReport.centre_report_id}`, {
        state: {
          data: {
            reportsDataWithScores: reportsDataWithScores,
            defaultReportData: lastReport,
            defaultCompoundMetaData: compoundMetaData,
          },
        },
      });
    }
  }, [reportsDataWithScores]);

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <GradientCircularProgress loadingMessage="Fetching latest report..." />
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '50vh' }}>{errorMessage}</Box>
  );
}
